import { createSlice } from "@reduxjs/toolkit";
import {
  getpgeactivityskillThunk,
  getmasteractivitiydetailsThunk,
  createmasteractivitiesThunk,
  updatemasteractivitiesThunk,
} from "./PgeActivity.Thunk";

const initialState = {
  data: [],
  skills: [],
  loading: false,
  status: "",
  message: "",
  preferedlanguage: "",
  clas: "",
  subject: "",
  skillsetid: "",
  skillsetname: "",
  disable_content_button: true,
};

const PgeActivitySlice = createSlice({
  name: "pgeactivityslice",
  initialState,
  reducers: {
    preferedlanguage_change: (state, action) => {
      state.preferedlanguage = action.payload;
      state.data = [];
      state.clas = "";
      state.subject = "";
      state.skillsetid = "";
      state.skillsetname = "";
      state.disable_content_button = true;
    },
    subject_change: (state, action) => {
      state.subject = action.payload;
      state.data = [];
      state.clas = "";
      state.skillsetid = "";
      state.skillsetname = "";
      state.disable_content_button = true;
    },
    class_change: (state, action) => {
      state.clas = action.payload;
      state.data = [];
      state.skillsetid = "";
      state.skillsetname = "";
      state.disable_content_button = true;
    },
    skill_change: (state, action) => {
      state.skillsetid = action.payload.skillsetid;
      state.skillsetname = action.payload.skillsetname;
      state.data = [];
      state.disable_content_button = false;
    },
  },
  extraReducers: {
    [getpgeactivityskillThunk.pending]: (state, action) => {
      state.skills = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getpgeactivityskillThunk.fulfilled]: (state, action) => {
      state.skills = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getpgeactivityskillThunk.rejected]: (state, action) => {
      state.skills = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [getmasteractivitiydetailsThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getmasteractivitiydetailsThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getmasteractivitiydetailsThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [createmasteractivitiesThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [createmasteractivitiesThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [createmasteractivitiesThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [updatemasteractivitiesThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [updatemasteractivitiesThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [updatemasteractivitiesThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export const {
  preferedlanguage_change,
  class_change,
  subject_change,
  skill_change,
} = PgeActivitySlice.actions;

export default PgeActivitySlice.reducer;
